import React, { useState } from 'react';
import {
  makeStyles, Dialog, Slide, Box, Typography, Button,
} from '@material-ui/core';
import SearchPlace from 'views/motorcycle_rental/components/widget/SearchPlace';
import OverlayStyle from 'views/motorcycle_rental/components/widget/OverlayStyle';
import CloseIcon from '@material-ui/icons/Close';
import { withTranslation } from 'config/i18n';
import SearchTimeModal from 'views/motorcycle_rental/components/widget/SearchTimeModal';

const useStyles = makeStyles((theme) => ({
  placeModalRoot: {
    // override pickup style in the overlay
    '& .MuiAutocomplete-root': {
      [theme.breakpoints.only('md')]: {
        marginRight: theme.spacing(2),
      },
      [theme.breakpoints.only('sm')]: {
        marginBottom: theme.spacing(3),
      },
      '& .MuiInputLabel-formControl': {
        top: theme.spacing(0),
        left: theme.spacing(0),
      },
      '& .MuiInputAdornment-root': {
        alignItems: 'center',
        '& .MuiSvgIcon-root': {
          width: theme.spacing(2),
          height: theme.spacing(2),
          fill: theme.palette.grey['800'],
        },
      },
    },
    // override dropoff style in the overlay
    "& [class*='searchDropoffGrid']": {
      width: '100%',
      [theme.breakpoints.only('md')]: {
        width: '50%',
      },
    },
    // override for pickup && dropoff
    '& label.MuiInputLabel-formControl': {
    },
  },
  ...OverlayStyle(theme),
  overlayTimeBox: {
    border: `1px solid ${theme.palette.grey[200]}`,
    borderRadius: '4px',
    maxWidth: '49%',
    height: theme.spacing(7),
    [theme.breakpoints.only('md')]: {
      marginTop: theme.spacing(3),
    },
    [theme.breakpoints.down('md')]: {
      maxWidth: '100%',
    },
    "& [class*='dateRangeWrapper']": {
      paddingTop: theme.spacing(1),
    },
    "& [class*='dateLabel']": {
      top: theme.spacing(-1.5),
      background: theme.palette.common.white,
      left: theme.spacing(1.25),
      padding: theme.spacing(0, 0.5),
    },
  },
}));

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

const SearchPlaceModal = ({ t, timeWidgetProps, placeWidgetProps }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  return (
    <>
      <Box display="flex" width="100%" height="100%" onClick={() => setOpen(true)}>
        <SearchPlace data={placeWidgetProps} hideDropoff readOnly />
      </Box>
      <Dialog
        fullScreen
        open={open}
        onClose={() => setOpen(false)}
        TransitionComponent={Transition}
        className={classes.placeModalRoot}
      >
        <Box width="100%" p={2}>
          <Box className={classes.overlayHeader}>
            <Typography className={classes.overlayTitle}>
              {t('fe_es_geo_widget:overlay.edit_your_serach')}
            </Typography>
            <CloseIcon onClick={() => setOpen(false)} className={classes.closeIcon} />
          </Box>
          <Box>
            <SearchPlace
              data={{
                ...placeWidgetProps,
                variant: 'outlined',
              }}
              hideDropoff={false}
            />
          </Box>
          <Box className={classes.overlayTimeBox}>
            <SearchTimeModal data={timeWidgetProps} disabled={timeWidgetProps.disabled} />
          </Box>
        </Box>
        <Box width="100%" p={2} display="flex" justifyContent="flex-end">
          <Button onClick={() => setOpen(false)} variant="contained" color="primary" fullWidth>
            {t('fe_es_geo_widget:overlay.save_search')}
          </Button>
        </Box>
      </Dialog>
    </>
  );
};

export default withTranslation(['fe_es_geo_widget'])(SearchPlaceModal);
